import { useState, useRef } from 'react';

import { InfoCircleOutlined } from '@ant-design/icons';
import sendAxios from '@lcsc-ui/utils/request';
import Utils from '@lcsc-ui/utils/Utils';
import { Drawer, Segmented, ConfigProvider, message, Modal } from 'antd';
import { styled } from 'styled-components';

const ScrollbarsStyles = styled.div`
  height: 100%;
  overflow: auto;
  padding-bottom: 20px;
  &::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 5px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
  }
  &::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 5px;
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #cfcfcf;
  }
  &::-webkit-scrollbar-thumb:hover {
    box-shadow: 8px 0 0 #cfcfcf inset;
    cursor: pointer;
  }
  &::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    border-radius: 10px;
    background: transparent;
  }
`;
export default function CouponDialog({ isOpen, onClose, couponData, loginStatus, clickSetCoupon }) {
  const [open, setOpen] = useState(isOpen);
  const [value, setValue] = useState('可领取');
  const useCouponRef = useRef(null);
  const waitReceiveListTest = couponData?.waitReceive || [];
  if (couponData?.plusList?.length > 0) {
    waitReceiveListTest.push(...(couponData?.plusList || []));
  }
  const receiveListTest = couponData?.receive || [];

  const closeFn = () => {
    setOpen(false);
    onClose();
  };

  const loginFn = (toLogin) => {
    if (toLogin) {
      window.location.href = '/login.html';
    } else {
      Modal.destroyAll();
    }
  };

  const alertDialog = (obj = {}) => {
    Modal.confirm({
      title: '提示',
      icon: null,
      closable: true,
      centered: true,
      content: obj.msg || '您尚未登录，请先登录后再领取优惠券',
      footer: () => {
        return (
          <div className="flex justify-end">
            {obj.showCancel && (
              <button
                className="mr-[15px] h-[32px] w-[70px] rounded-[4px] border-[1px]
          border-solid border-[rgba(0,0,0,0.15)] bg-[#FFFFFF] text-[black]
          hover:border-[#0093E6] hover:text-[#0093E6]"
                onClick={() => Modal.destroyAll()}
              >
                取消
              </button>
            )}
            <button
              className="mr-[15px] h-[32px] rounded-[4px] bg-[#0093E6] pl-[15px] pr-[15px] text-[white] hover:opacity-[0.8]"
              onClick={() => loginFn(obj.toLogin)}
            >
              {obj.toLogin ? '登录' : '确定'}
            </button>
          </div>
        );
      },
    });
  };

  // 立即使用优惠券
  const onUseCoupon = (link) => {
    let url = link;
    if (useCouponRef.current) {
      url = Utils.getBtnSpmQueryUrl(url, useCouponRef.current);
    }
    // 立即使用优惠券直接跳转到类目页
    window.open(url);
  };

  // 立即抢券
  const getCoupon = (item) => {
    if (loginStatus !== 'yes') {
      message.error('您尚未登录，请先登录后再领取优惠券');
      setTimeout(() => {
        window.location.href = '/login.html';
      }, 2000);
      return;
    }
    sendAxios({
      method: 'GET',
      baseURL: 'lcscActivityUrl',
      url: `/getCoupon/${item.uuid}`,
    }).then((res) => {
      if (res?.result === 'needLogin') {
        alertDialog({ msg: res.msg, showCancel: true, toLogin: true });
        return;
      }
      if (res?.result === 'success') {
        clickSetCoupon();
        let msg = `优惠券领取成功，有效日期至${Utils.dateFormat(new Date(res.useCouponEndDate), 'yyyy年MM月dd日')}${res.couponModel && res.couponModel.limitProductCodes ? `, 以下商品不可用：${res.couponModel.limitProductCodes}` : ''}`;
        if (item.useChannel === 'app') {
          msg += ',限移动端下单使用';
        }
        const { customerMaxNum, isDayLimit } = res.couponModel;
        if (customerMaxNum && customerMaxNum !== 1) {
          msg += `,单客编限领取：${customerMaxNum}张${isDayLimit ? '/天' : ''}`;
        }
        message.success(msg);
      } else {
        message.error(res?.msg);
      }
    });
  };

  return (
    <>
      <Drawer
        title="领券通知"
        placement="right"
        open={open}
        mask={true}
        maskClosable={true}
        headerStyle={{
          color: '#000000',
          fontSize: '16px',
          borderBottom: 'none',
        }}
        bodyStyle={{
          padding: '0px',
        }}
        maskStyle={{
          backgroundColor: 'rgba(0, 0, 0, 0)',
        }}
        style={{ overflow: 'hidden' }}
        width={266}
        onClose={closeFn}
      >
        <ScrollbarsStyles>
          <div data-spm="cou" className="p-[0_20px]">
            <ConfigProvider
              theme={{
                components: {
                  Segmented: {
                    itemSelectedColor: '#0093E6',
                  },
                },
              }}
            >
              <Segmented
                block={true}
                options={['可领取', '已领取']}
                value={value}
                itemColor="red"
                onChange={(value) => {
                  setValue(value);
                }}
              />
            </ConfigProvider>
            {value === '可领取' ? (
              <ul>
                {waitReceiveListTest?.map((item) => (
                  <li
                    className={`${item?.customerType === 'plus' ? 'bg-coupon-plus' : 'bg-coupon'} relative mt-[16px] h-[139px] w-[226px] cursor-pointer bg-cover p-[20px_20px_7px_20px] text-[12px] ${item?.customerType === 'plus' ? 'text-[#D2925C]' : 'text-[#0093E6]'}`}
                    key={item.uuid}
                  >
                    <ul className="flex flex-wrap items-center justify-between">
                      <li className="w-[60%] text-left leading-[25px]">
                        {item.couponAmount === 0 && item.isFreeExpress ? (
                          <span className="overflow-hidden whitespace-nowrap text-[24px] font-bold">包邮券</span>
                        ) : item.couponType === 'discount' ? (
                          <>
                            <span className="overflow-hidden whitespace-nowrap text-[24px] font-bold">
                              {item.couponDiscount / 10}
                            </span>
                            <span className="text-[20px] font-bold">折</span>
                          </>
                        ) : (
                          <>
                            <span className="text-[20px] font-bold">￥</span>
                            <span className="overflow-hidden whitespace-nowrap text-[24px] font-bold">
                              {item.couponAmount}
                            </span>
                          </>
                        )}
                      </li>
                      <li
                        className="w-[40%] text-right text-[12px]"
                        title={
                          item.minOrderMoney > 0
                            ? `${item.isOrderActualMoney ? '实付满' : '满'}${item.minOrderMoney}可用`
                            : '不限金额'
                        }
                      >
                        <p className="w-[100%] overflow-hidden text-ellipsis whitespace-nowrap">
                          {item.minOrderMoney > 0
                            ? `${item.isOrderActualMoney ? '实付满' : '满'}${item.minOrderMoney}可用`
                            : '不限金额'}
                        </p>
                      </li>
                      <li
                        className="mt-[10px] flex w-[60%] justify-start"
                        title={item.useChannel === 'app' ? `移动端专享-${item.couponName}` : item.couponName}
                      >
                        <h3 className="overflow-hidden text-ellipsis whitespace-nowrap">
                          {item.useChannel === 'app' ? `移动端专享-${item.couponName}` : item.couponName}
                        </h3>
                        {item.couponAmount === 0 && item.isFreeExpress && item.maxFreeExpressAmount ? (
                          <InfoCircleOutlined
                            style={{ color: '#FF7900' }}
                            className="ml-[2px]"
                            title={`最高可抵扣${item.maxFreeExpressAmount}元运费`}
                          />
                        ) : (
                          ''
                        )}
                      </li>
                      <li
                        className="mt-[10px] flex w-[40%] items-center justify-end text-right text-[12px]"
                        title={
                          item.minOrderMoney > 0
                            ? `${item.isOrderActualMoney ? '实付满' : '满'}${item.minOrderMoney}可用`
                            : '不限金额'
                        }
                      >
                        <span>已领{item.receiveCustomerNum}</span>
                        {item.customerMaxNum && item.customerMaxNum !== 1 ? (
                          <InfoCircleOutlined
                            className="ml-[2px]"
                            title={
                              item.isDayLimit
                                ? `单客编限领取：${item.customerMaxNum}张/天`
                                : `单客编限领取：${item.customerMaxNum}张`
                            }
                          />
                        ) : (
                          ''
                        )}
                      </li>
                      <li>
                        <button
                          onClick={() => getCoupon(item)}
                          className={`h-[32px] w-[183px] ${item.customerType === 'plus' ? 'bg-[#D2925C]' : 'bg-[#0093E6]'} mt-[21px] rounded-[6px] bg-[#0093E6] text-[white] hover:opacity-[0.8]`}
                        >
                          立即抢券
                        </button>
                      </li>
                    </ul>
                    {item.isShowCouponLabel ? (
                      <div
                        className="absolute right-[0px] top-[0px] h-[60px] w-[60px] bg-coupon-tag  bg-cover"
                        title={item.couponLabelName}
                      >
                        <p className="relative right-[-8px] top-[9px] w-[60px] rotate-[40deg] overflow-hidden text-ellipsis whitespace-nowrap text-center text-[12px] text-[white]">
                          {item.couponLabelName}
                        </p>
                      </div>
                    ) : (
                      ''
                    )}
                  </li>
                ))}
              </ul>
            ) : (
              <ul>
                {receiveListTest?.map((item) => (
                  <li
                    className={`${item.customerType === 'plus' ? 'bg-coupon-plus-receive' : 'bg-coupon-receive'} relative ${item.used ? 'cursor-default' : 'cursor-pointer'}  mt-[16px] h-[139px] w-[100%] bg-cover p-[20px_20px_7px_20px] text-[12px] ${item.customerType === 'plus' ? 'text-[#D2925C]' : 'text-[white]'}`}
                    key={item.uuid}
                  >
                    <ul className="flex flex-wrap items-center justify-between">
                      <li className="w-[60%] text-left leading-[25px]">
                        {item.couponAmount === 0 && item.isFreeExpress ? (
                          <span className="overflow-hidden whitespace-nowrap text-[24px] font-bold">包邮券</span>
                        ) : item.couponType === 'discount' ? (
                          <>
                            <span className="overflow-hidden whitespace-nowrap text-[24px] font-bold">
                              {item.couponDiscount / 10}
                            </span>
                            <span className="text-[20px] font-bold">折</span>
                          </>
                        ) : (
                          <>
                            <span className="text-[20px] font-bold">￥</span>
                            <span className="overflow-hidden whitespace-nowrap text-[24px] font-bold">
                              {item.couponAmount}
                            </span>
                          </>
                        )}
                      </li>
                      <li
                        className="w-[40%] text-right text-[12px]"
                        title={
                          item.minOrderMoney > 0
                            ? `${item.isOrderActualMoney ? '实付满' : '满'}${item.minOrderMoney}可用`
                            : '不限金额'
                        }
                      >
                        <p className="w-[100%] overflow-hidden text-ellipsis whitespace-nowrap">
                          {item.minOrderMoney > 0
                            ? `${item.isOrderActualMoney ? '实付满' : '满'}${item.minOrderMoney}可用`
                            : '不限金额'}
                        </p>
                      </li>
                      <li
                        className="mt-[10px] flex w-[60%] justify-start"
                        title={item.useChannel === 'app' ? `移动端专享-${item.couponName}` : item.couponName}
                      >
                        <span className="overflow-hidden text-ellipsis whitespace-nowrap">
                          {item.useChannel === 'app' ? `移动端专享-${item.couponName}` : item.couponName}
                        </span>
                        {item.couponAmount === 0 && item.isFreeExpress && item.maxFreeExpressAmount ? (
                          <InfoCircleOutlined
                            style={{ color: '#FF7900' }}
                            className="ml-[2px]"
                            title={`最高可抵扣${item.maxFreeExpressAmount}元运费`}
                          />
                        ) : (
                          ''
                        )}
                      </li>
                      <li
                        className="mt-[10px] flex w-[40%] items-center justify-end text-right text-[12px]"
                        title={
                          item.minOrderMoney > 0
                            ? `${item.isOrderActualMoney ? '实付满' : '满'}${item.minOrderMoney}可用`
                            : '不限金额'
                        }
                      >
                        <span>已领{item.receiveCustomerNum}</span>
                        {item.customerMaxNum && item.customerMaxNum !== 1 ? (
                          <InfoCircleOutlined
                            className="ml-[2px]"
                            title={
                              item.isDayLimit
                                ? `单客编限领取：${item.customerMaxNum}张/天`
                                : `单客编限领取：${item.customerMaxNum}张`
                            }
                          />
                        ) : (
                          ''
                        )}
                      </li>
                      <li>
                        <button
                          data-spm="use"
                          ref={useCouponRef}
                          onClick={() => onUseCoupon(item?.targetUrl)}
                          className={`h-[32px] w-[183px] ${item.customerType === 'plus' ? 'text-[#D2925C]' : 'text-[#0093E6]'} mt-[21px] rounded-[6px] bg-[white] hover:opacity-[0.8]`}
                        >
                          {'立即使用'}
                        </button>
                      </li>
                    </ul>
                    {item.isShowCouponLabel ? (
                      <div
                        className="absolute right-[0px] top-[0px] h-[50px] w-[50px] bg-coupon-tag  bg-cover"
                        title={item.couponLabelName}
                      >
                        <p className="h-50px relative right-[-9px] top-[8px] w-[50px] rotate-[40deg] overflow-hidden text-ellipsis whitespace-nowrap text-center text-[12px] text-[white]">
                          {item.couponLabelName}
                        </p>
                      </div>
                    ) : (
                      ''
                    )}
                  </li>
                ))}
              </ul>
            )}
          </div>
        </ScrollbarsStyles>
      </Drawer>
    </>
  );
}
